import React from "react";
import Products from "../../Component/Products";

const MainProducts = () => {
	return <Products />;
};

export default MainProducts;
